import { render, staticRenderFns } from "./TabelaManutencao.vue?vue&type=template&id=74be0de5&"
import script from "./TabelaManutencao.vue?vue&type=script&lang=ts&"
export * from "./TabelaManutencao.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports